import React, { PropTypes } from 'react';
import classNames from 'classnames';
import uuid from 'uuid';
import './Radio.less';

class Radio extends React.Component {
  constructor(props) {
    super(props);

    this.inputId = uuid.v1();
  }

  render () {
    const {inputId} = this;
    const {className, label, checked, onChange} = this.props;
    const rootClasses = classNames('input-field radio', className);

    return (
      <div className={rootClasses}>
        <input type="radio" checked={checked} onChange={onChange} id={inputId}/>
        {label && (<label htmlFor={inputId}>{label}</label>)}
      </div>
    );
  }
}

Radio.propTypes = {
  className: PropTypes.string,
  label: PropTypes.node,
  checked: PropTypes.bool,
  onChange: PropTypes.func
};

export default Radio;



// WEBPACK FOOTER //
// ./src/components/common/Radio/Radio.js